import { RouteConfig } from 'vue-router';
import { routes as sharedRoutes } from '../modules/shared/routes';
import Breadcrumbs from './breadcrumbs';
import i18n from '@/plugins/i18n';


const Home = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "Home" */ '@/pages/home/Home');
const Test = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "Test" */ '@/pages/test-page/TestPage');

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'home',
    // component: Home,
    redirect: { name: 'Verify' }, // Redirect to the route by name
    // component: Index,
  },
  // {
  //   path: '/[route]',
  //   name: '[Test-Component]',
  //   component: Test,
  //   meta: {
  //     breadcrumb: Breadcrumbs.test,
  //     highlighted: true,
  //   },
  // },
  {
    path: '/Verify',
    name: 'Verify',
    component: Test,
    meta: {
      breadcrumb: Breadcrumbs.test,
      highlighted: true,
      pageTitle: i18n.t('wekalaVerification.pageTitle'),
      showPageTitle: true
    },
  },
  ...sharedRoutes,
];

export default routes;
